<template>
 <!-- 详情页左右侧 文本内容 -->
  <div>
    <p>
      <span class="strong">{{widget.label || widget.id}}</span>
    </p>
    <div class="hover-shadow box-border-7" v-html="widget.parameter"/>
  </div>
</template>

<script>
export default {
  name : 'TicketWidgetLiteral',

  props : ['widget']
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketWidgetLiteral.vue